import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Subscription Success Page
 *
 * Shown after Stripe Checkout completes successfully.
 * The webhook handler will have already activated the company's subscription.
 */
export default function SubscriptionSuccess(): React.ReactElement {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation Header */}
      <nav className="bg-white/80 backdrop-blur-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center">
              <img src="/logo1.png" alt="Nivoon" className="h-16" />
            </Link>
          </div>
        </div>
      </nav>

      {/* Success Content */}
      <div className="flex items-center justify-center py-24 px-4">
        <div className="max-w-md w-full text-center">
          {/* Check Icon */}
          <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-8">
            <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Subscription Activated
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            Your payment was successful and your account is now active. You can log in and start using Nivoon.
          </p>

          <Link
            to="/login"
            className="inline-block px-8 py-4 bg-gradient-to-r from-indigo-600 to-blue-600 text-white font-semibold rounded-lg hover:from-indigo-700 hover:to-blue-700 transition-all text-lg shadow-lg"
          >
            Go to Login
          </Link>

          <p className="text-sm text-gray-400 mt-6">
            You'll receive a receipt via email from Stripe.
          </p>
        </div>
      </div>
    </div>
  );
}
